var render = function render(){var _vm=this,_c=_vm._self._c;return _c('portal-target',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVisible),expression:"isVisible"}],staticClass:"c-sidebar",attrs:{"data-cy":"DefaultSidebar","name":"sidebar"},on:{"change":_vm.handleUpdate}})
}
var staticRenderFns = []

export { render, staticRenderFns }